/**
 * Body of `PATCH user/password`. The keys are the contract's own snake_case —
 * they are sent as written and are the same keys a `422` reports errors under.
 */
export interface PasswordChangeRequest {
  /** Password in force right now; the API is the one that checks it. */
  readonly current_password: string;
  readonly password: string;
  readonly password_confirmation: string;
}

/**
 * Fields the endpoint reports a `422` under. Each one maps to a control on the
 * account form, so its message is shown next to the input instead of toasted.
 */
export const PASSWORD_FIELD_KEYS: ReadonlySet<string> = new Set([
  'current_password',
  'password',
  'password_confirmation',
]);

/** Sentence the API worded for a refused field, keyed by that field. */
export type PasswordFieldErrors = Readonly<Record<string, string>>;

/** Status of the password-change lifecycle. */
export type PasswordChangeStatus = 'idle' | 'saving' | 'saved' | 'error';

/** Answer of a successful change: the API's own sentence, when it words one. */
export interface PasswordChangeResult {
  readonly message: string | null;
}
